import { ResearchQuestionInterface } from "../../interfaces/ResearchQuestion";
import TypeOriginQuestion from "../../interfaces/TypeOriginQuestion";
import ValueSearch from "../../interfaces/ValueSearch";

interface Mapper<T, U> {
    (json: T): U;
}

type mapValueResearch = Mapper<ResearchQuestionInterface, ValueSearch>;
type mapTypeOriginQuestion = Mapper<ResearchQuestionInterface, TypeOriginQuestion>;

export function mapValueResearch(json: ResearchQuestionInterface): ValueSearch  {
    return {
        id: json.idValoresPesquisa.id,
        dsValorPesquisa: json.idValoresPesquisa.dsValorPesquisa,
        vlrPesquisa: json.idValoresPesquisa.vlrPesquisa,
        nrOrdem: json.idValoresPesquisa.nrOrdem,
        flHabilitado: json.idValoresPesquisa.flHabilitado,
        //imgPontuacao: json.idValoresPesquisa.imgPontuacao,
        vlrMinimo: json.idValoresPesquisa.vlrMinimo,
        vlrMaximo: json.idValoresPesquisa.vlrMaximo
    };
}

export function mapTypeOriginQuestion(json: ResearchQuestionInterface): TypeOriginQuestion {
    return {
        id: json.idTipoOrigemPergunta.id,
        dsTipoPergunta: json.idTipoOrigemPergunta.dsTipoPergunta,
        flAtivo: json.idTipoOrigemPergunta.flAtivo
    }
}